import React from 'react'

export default function MenuIcon({ outline, className }) {
	return (
		<svg width="20" height="20" viewBox="0 0 24 24" fill="gray" xmlns="http://www.w3.org/2000/svg">
			<rect y="16" width="24" height="1" fill="gray" />
			<rect y="12" width="24" height="1" fill="gray" />
			<rect y="8" width="24" height="1" fill="gray" />
		</svg>
	)
}

MenuIcon.displayName = 'MenuIcon'
